<template>
	<div class="userList column-me">
		<div class="card-view column-me">
			<el-page-header @back="goBack" content="试卷信息详情页面"></el-page-header>
			<el-divider></el-divider>
			<div class="row-me row-center">
				<el-descriptions title="试卷基础信息" style="width: 100%;" :column = "4" border>
				  	<el-descriptions-item label="试卷标题 :">{{dataInfo.title}} </el-descriptions-item>
				  	<el-descriptions-item label="试卷类型 :">{{dataInfo.type == 1 ? '练习试卷' : '考试试卷'}}</el-descriptions-item>
				  	<el-descriptions-item label="试卷分类 :">
						<el-cascader
							:options="classTableData"
							placeholder="请选择试卷分类"
							:props="{ checkStrictly: true , emitPath:false }"
							disabled
							v-model="dataInfo.spe_sub_id"
						></el-cascader>
					</el-descriptions-item>
					<el-descriptions-item label="单选题数量 :"><el-tag size="small">{{dataInfo.single_num}}</el-tag></el-descriptions-item>
					<el-descriptions-item label="多选题数量 :"><el-tag size="small">{{dataInfo.multiple_num}}</el-tag></el-descriptions-item>
					<el-descriptions-item label="判断题数量 :"><el-tag size="small">{{dataInfo.judgment_num}}</el-tag></el-descriptions-item>
					<el-descriptions-item label="填空题数量 :"><el-tag size="small">{{dataInfo.blank_num}}</el-tag></el-descriptions-item>
					<el-descriptions-item label="简答题数量 :"><el-tag size="small">{{dataInfo.brief_num}}</el-tag></el-descriptions-item>
				</el-descriptions>
			</div>
<!-- 		</div>
		<div class="card-view column-me"> -->
			<!--===========================单选题开始===========================-->
			<div class="row-me row-center margin-top20 width100Per" style="display: block;" v-if="singleSelectData.length != 0">
				<el-alert title="单选题:" type="success" :closable="false"> </el-alert>
				<div class="margin-top20" v-for="[key, value] in Object.entries(singleSelectData)" :key="key">
					<div class="stemClass"  v-if="value.stem_is_img == 1"><span>{{getAdjustedIndex(key)}}</span>
						<div class="optionImage">
							<el-image
								:src="value.image"
								fit="scale-down"
								:preview-src-list="[value.image]"
								hide-on-click-modal
							></el-image>
						</div>
					</div>
					<div class="stemClass"  v-if="value.stem_is_img == 2"><span>{{getAdjustedIndex(key)}}</span>{{value.stem}}</div>
					<div class="stemClass"  v-if="value.stem_is_img == 3">
						<span>{{getAdjustedIndex(key)}}</span>
						{{value.stem}}
						<el-tag size="small">图片可点击放大查看</el-tag>
					</div>
					<div class="stemClass"  v-if="value.stem_is_img == 3">
						<el-image
							:src="value.image"
							fit="scale-down"
							:preview-src-list="[value.image]"
							hide-on-click-modal
						></el-image>
					</div>
					<el-divider></el-divider>
					<div class="stemClass">
						<div class="row-me row-center margin-left20" v-if="value.option_is_img == 1">
							<div class="optionClass" v-for="[key, value] in Object.entries(value.option)" :key="key">
								<div class="optionImageTitle">{{key}}</div>
								<div class="optionImage">
									<el-image
										:src="value"
										fit="scale-down"
										:preview-src-list="[value]"
										hide-on-click-modal
									></el-image>
								</div>
							</div>
						</div>
						<div class="margin-left20" v-if="value.option_is_img == 2">
							<div class="optionClass" v-for="[k, v] in Object.entries(value.option)" :key="k">{{k}}&nbsp;&nbsp;&nbsp;{{v.answer}}</div>
						</div>
					</div>
					<div class="setmAnswer margin-top20">{{greatAnswerStr(value.answer,value.type)}}</div>
					<div class="row-me row-center margin-top20">
						<el-tag style="font-size: 14px; font-weight: 500;" size="large" effect="dark" >答案解析：</el-tag>
					</div>
					<div class="row-me row-center margin-top20">
						<div class="setmBrief" v-html="value.analysis"></div>
					</div>
				</div>
			</div>
			<!--===========================单选题结束===========================-->
			<!--===========================多选题开始===========================-->
			<div class="row-me row-center margin-top20 width100Per" style="display: block;" v-if="multipleSelectData.length != 0">
				<el-alert title="多选题:" type="success" :closable="false"> </el-alert>
				<div class="margin-top20" v-for="[key, value] in Object.entries(multipleSelectData)" :key="key">
					<div class="stemClass"  v-if="value.stem_is_img == 1"><span>{{getAdjustedIndex(key)}}</span>
						<el-image
							class="setmImage"
							:src="value.image"
							fit="scale-down"
							:preview-src-list="[value.image]"
							hide-on-click-modal
						></el-image>
					</div>
					<div class="stemClass"  v-if="value.stem_is_img == 2"><span>{{getAdjustedIndex(key)}}</span>{{value.stem}}</div>
					<div class="stemClass"  v-if="value.stem_is_img == 3">
						<span>{{getAdjustedIndex(key)}}</span>
						{{value.stem}}
					</div>
					<div class="stemClass"  v-if="value.stem_is_img == 3">
						<el-image
							class="setmImage"
							:src="value.image"
							fit="scale-down"
							:preview-src-list="[value.image]"
							hide-on-click-modal
						></el-image>
					</div>
					<el-divider></el-divider>
					<div class="stemClass">
						<div class="row-me row-center margin-left20" v-if="value.option_is_img == 1">
							<div class="optionClass" v-for="[key, value] in Object.entries(value.option)" :key="key">
								<div class="optionImageTitle">{{key}}</div>
								<div class="optionImage">
									<el-image
										:src="value"
										fit="scale-down"
										:preview-src-list="[value]"
										hide-on-click-modal
									></el-image>
								</div>
							</div>
						</div>
						<div class="margin-left20" v-if="value.option_is_img == 2">
							<div class="optionClass" v-for="[k, v] in Object.entries(value.option)" :key="k">{{k}}&nbsp;&nbsp;&nbsp;{{v.answer}}</div>
						</div>
					</div>
					<div class="setmAnswer margin-top20">{{greatAnswerStr(value.answer,value.type)}}</div>
					<div class="row-me row-center margin-top20">
						<el-tag style="font-size: 14px; font-weight: 500;" size="large" effect="dark" >答案解析：</el-tag>
					</div>
					<div class="row-me row-center margin-top20">
						<div class="setmBrief" v-html="value.analysis"></div>
					</div>
				</div>
			</div>
			<!--===========================多选题结束===========================-->
			<!--===========================填空题开始===========================-->
			<div class="row-me row-center margin-top20 width100Per" style="display: block;" v-if="blankSelectData.length != 0">
				<el-alert title="填空题:" type="success" :closable="false"> </el-alert>
				<div class="margin-top20" v-for="[key, value] in Object.entries(blankSelectData)" :key="key">
					<div class="stemClass"  v-if="value.stem_is_img == 1"><span>{{getAdjustedIndex(key)}}</span>
						<el-image
							class="setmImage"
							:src="value.image"
							fit="scale-down"
							:preview-src-list="[value.image]"
							hide-on-click-modal
						></el-image>
					</div>
					<div class="stemClass"  v-if="value.stem_is_img == 2"><span>{{getAdjustedIndex(key)}}</span>{{value.stem}}</div>
					<div class="stemClass"  v-if="value.stem_is_img == 3">
						<span>{{getAdjustedIndex(key)}}</span>
						{{value.stem}}
						<el-tag size="small">图片可点击放大查看</el-tag>
					</div>
					<div class="stemClass"  v-if="value.stem_is_img == 3">
						<el-image
							class="setmImage"
							:src="value.image"
							fit="scale-down"
							:preview-src-list="[value.image]"
							hide-on-click-modal
						></el-image>
					</div>
					<div class="setmAnswer margin-top20" v-if="value.answer_is_img == 1"><b>答案：</b></div>
					<div class="row-me row-center margin-left20" v-if="value.answer_is_img == 1">
						<div class="optionClass" style="width: 50% !important; height: 225px;" v-for="[key, value] in Object.entries(value.answer)" :key="key">
							<div class="optionImageTitle">{{answerKeyStr[key]}}</div>
							<div class="optionImage">
								<el-image
									:src="value"
									fit="scale-down"
									:preview-src-list="[value]"
									hide-on-click-modal
								></el-image>
							</div>
						</div>
					</div>
					<div class="setmAnswer margin-top20" v-if="value.answer_is_img == 2">{{greatAnswerStr(value.answer,value.type)}}</div>
					<div class="row-me row-center margin-top20">
						<el-tag style="font-size: 14px; font-weight: 500;" size="large" effect="dark" >答案解析：</el-tag>
					</div>
					<div class="row-me row-center margin-top20">
						<div class="setmBrief" v-html="value.analysis"></div>
					</div>
				</div>
			</div>
			<!--===========================填空题结束===========================-->
			<!--===========================简答题开始===========================-->
			<div class="row-me row-center margin-top20 width100Per" style="display: block;" v-if="briefSelectData.length != 0">
				<el-alert title="简答题:" type="success" :closable="false"> </el-alert>
				<div class="margin-top20" v-for="[key, value] in Object.entries(briefSelectData)" :key="key">
					<div class="stemClass"  v-if="value.stem_is_img == 1">
						<span>{{getAdjustedIndex(key)}}</span>
						<el-image
							class="setmImage"
							:src="value.image"
							fit="scale-down"
							:preview-src-list="[value.image]"
							hide-on-click-modal
						></el-image>
					</div>
					<div class="stemClass"  v-if="value.stem_is_img == 2"><span>{{getAdjustedIndex(key)}}</span>{{value.stem}}</div>
					<div class="stemClass"  v-if="value.stem_is_img == 3">
						<span>{{getAdjustedIndex(key)}}</span>
						{{value.stem}}
						<el-tag size="small">图片可点击放大查看</el-tag>
					</div>
					<div class="stemClass"  v-if="value.stem_is_img == 3">
						<el-image
							class="setmImage"
							:src="value.image"
							fit="scale-down"
							:preview-src-list="[value.image]"
							hide-on-click-modal
						></el-image>
					</div>
					<div class="setmAnswer margin-top20" v-if="value.answer_is_img == 1"><b>答案：</b></div>
					<div class="row-me row-center margin-left20" v-if="value.answer_is_img == 1">
						<div class="optionClass" v-for="[key, value] in Object.entries(value.answer)" :key="key">
							<div class="optionImage">
								<el-image
									:src="value"
									fit="scale-down"
									:preview-src-list="[value]"
									hide-on-click-modal
								></el-image>
							</div>
						</div>
					</div>
					<div class="setmAnswer margin-top20" v-if="value.answer_is_img == 2">{{greatAnswerStr(value.answer,value.type)}}</div>
					<div class="row-me row-center margin-top20">
						<el-tag style="font-size: 14px; font-weight: 500;" size="large" effect="dark" >答案解析：</el-tag>
					</div>
					<div class="row-me row-center margin-top20">
						<div class="setmBrief" v-html="value.analysis"></div>
					</div>
				</div>
			</div>
			<!--===========================简答题结束===========================-->
		</div>
	</div>
</template>

<script>
// import E from 'wangeditor'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
export default {
	components: {},
	data() {
		return {
			id:'',
			dataInfo:{
				id: '',
				title: '',
				type: '',
				spe_sub_id: '',
				single_num: 0,
				multiple_num: 0,
				judgment_num: 0,
				blank_num: 0,
				brief_num: 0,
				method: 1,
				statue: 2,
				question_arr:[]
			},
			answerKeyStr:['①','②','③','④','⑤','⑥','⑥','⑦','⑧','⑨','⑩'],
			classTableData:'',
			singleSelectData:[],
			multipleSelectData:[],
			judgmentSelectData:[],
			blankSelectData:[],
			briefSelectData:[]
		}
	},
	// 侦听器
	watch: {},
	// 计算属性
	computed: {},
	//html加载完成之前
	created() {
		this.id = this.$route.query.id;
		this.getDataDetails();
	},
	// html加载完成后执行。
	mounted() {
		this.$nextTick(() => {
		    const img = this.$el.querySelector('img'); // 确保在DOM更新后查询元素
		    if (img) {
		      img.style.width = '100px'; // 设置宽度
		      img.style.height = '100px'; // 设置高度
		    }
		  });
	},
	// 事件方法执行
	methods: {
		goBack() {
		    this.$router.go(-1)
		},
		//试题标号
		getAdjustedIndex(index){
			const Num = Number(index) + 1;
			return Num+'.';
		},
		//答案数据结构构造
		greatAnswerStr(arr,type){
			var answer = '';
			switch(type){
				case 1:
					answer = '答案：' + arr[0];
				break;
				case 2:
					answer = '答案：' + arr.join("；");
				break;
				case 4:
					const tempArr = [];
					for(let i = 0; i < arr.length; i++){
						const ress = this.answerKeyStr[i] +' : '+ arr[i];
						tempArr.push(ress);
					}
					answer = '答案：' + tempArr.join("；");
				break;
				default:
				break;
			}
			return answer;
		},
		//答案解析增加前缀
		greatBrief(val){
			return '<b>答案解析：</b>' + val;
		},
		//获取试卷信息详情并构造数据结构
		getDataDetails(){
			this.$post('/admin/examinaInfo', {
			  id: this.id
			}).then((res) => {
			  if (res) {
			    this.dataInfo = res.data;
				console.log(this.dataInfo);
				this.dataInfo.questionList.forEach(e=>{
					switch(e.type){
						case 1:
							this.singleSelectData.push(e);
						break;
						case 2:
							this.multipleSelectData.push(e);
						break;
						case 3:
							this.judgmentSelectData.push(e);
						break;
						case 4:
							this.blankSelectData.push(e);
						break;
						case 5:
							this.briefSelectData.push(e);
						break;
					}
				})
				console.log(this.singleSelectData);
				//=====================================已选试题赋值
			    this.addInfoBox = true;
			  }
			}).catch((error) => {
				//console.log(error)
			})
		},
		//素材分类数据获取
		getClassifyData(){
			this.$post('/admin/specialSubList').then((res) => {
				if (res) {
					// console.log(res);
					this.classTableData = res.data;
				}
			}).catch((error) => {
				console.log(error)
			})
		}
	},
}
</script>

<style lang="scss" scoped>
.small-image {
  width: 100px;
  height: 100px;
}
.userList {
	height: 100%;
	.stemTitle{
		//float: left;
		width: 100% !important;
		font-size: 14px;
		font-weight: bold;
		height: 40px;
		overflow: hidden;
		line-height: 40px;
	}
	.stemClass{
		font-size: 14px;
		line-height: 30px;
		font-weight: bold;
		height: auto;
		overflow: hidden;
		color: #000000;
		span{
			float: left;
		}
		.setmImage{
			float: left;
			//margin-left: calc(50% - 180px);
			width: 80%;
			height: 225px;
			overflow: hidden;
		}
		.optionClass{
			display: block;
			font-size: 14px;
			font-weight: 500;
			line-height: 30px;
			height: auto;
			width: 100%;
			padding: 0px 10px 0px 0px;
			.optionImageTitle{
				float: left;
				width: 30px;
				line-height: 225px;
				height: 225px;
			}
			
		}
	}
	.stemClass .optionClass .optionImage{
				float: left;
				width: 360px;
				height: 225px;
			}
	.stemClass .optionClass .optionImage .el-image{
		width: 360px;
		height: 225px;
		overflow: hidden;
	}	
	.setmAnswer{
		font-size: 14px;
		line-height: 40px;
		background-color: #f4f4f5;
		color: #909399;
		padding: 0px 20px 0px 20px;
	}
	.setmBrief{
		float: left;
		width: 100%;
		overflow: hidden;
	}
	.setmBrief img{
		width: 500px;
		height: auto;
	}
	
	
	
}
</style>
